import { createStore } from "zustand/vanilla";

/** `confirm()` に渡す表示オプション。`tone` は確定ボタンの見た目（danger＝破棄などの危険操作）。 */
export type ConfirmOptions = {
    title: string;
    body?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    tone?: "default" | "danger";
};

/** 保留中の確認リクエスト（表示オプション＋解決関数）。同時に高々1件。 */
type PendingConfirm = ConfirmOptions & { resolve: (ok: boolean) => void };

type ConfirmState = {
    pending: PendingConfirm | null;
    /** ユーザーの選択で解決する（ConfirmHost から呼ぶ内部アクション）。 */
    settle: (ok: boolean) => void;
};

/**
 * 確認ダイアログのモジュール単一ストア（`notify`/`toastStore` と同型）。
 * `confirm(...)` が保留を積み、ユーザー操作で解決してクリアする。いずれもイベント起点の `set`。
 */
export const confirmStore = createStore<ConfirmState>((set, get) => ({
    pending: null,
    settle: (ok) => {
        const p = get().pending;
        if (!p) return;
        set({ pending: null });
        p.resolve(ok);
    },
}));

/**
 * 確認ダイアログを出し、確定＝`true` / キャンセル＝`false` を返す。`window.confirm` の非同期版。
 * イベントハンドラから `if (await confirm({ ... })) { ... }` の形で使う。
 * すでに確認が開いているときは、後続を即 `false` で解決する（同時に高々1件・モーダル）。
 */
export function confirm(options: ConfirmOptions): Promise<boolean> {
    if (confirmStore.getState().pending) return Promise.resolve(false);
    return new Promise<boolean>((resolve) => {
        confirmStore.setState({ pending: { ...options, resolve } });
    });
}
